<template>
  <div>
    <h5 v-if="createAfterTableData.length !== 0">
      {{ $t('key1004781') }}{{ createAfterTableData.length }}{{ $t('key1004782') }} </h5>
    <Table border :columns="columns" :data="createAfterTableData"></Table>
  </div>
</template>
<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

export default {
  props: ['data', 'createAfterTableData'],
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004779'),
          key: 'code'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004688'),
          key: 'type',
          render(h, params) {
            return h('span', params.row.packageGoodsType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000203') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000202'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004780'),
          key: 'warehouseName'
        }
      ]
    };
  },
  created() {
  },
  computed: {},
  destroyed() {
    this.$parent.$parent.createAfterTableData = [];
  }
};
</script>

<style></style>
